import { Error } from './interfaces';
import { AnyAction } from 'redux';
import { authActionTypes, authActionsInterfaces } from '.';

export const checkToken = () =>
  ({
    type: authActionTypes.CHECK_TOKEN,
  } as const);
export const whoAmI = () =>
  ({
    type: authActionTypes.WHO_AM_I_START,
  } as const);
type WhoAmISuccessPayload = AppConfig.User & { parent?: AppConfig.User };
export const whoAmISuccess = (user: WhoAmISuccessPayload, token: authActionsInterfaces.Token) =>
  ({
    type: authActionTypes.WHO_AM_I_SUCCESS,
    payload: { user, token },
  } as const);
export const whoAmIFail = () =>
  ({
    type: authActionTypes.WHO_AM_I_FAIL,
  } as const);
export const whoAmIBackground = () =>
  ({
    type: authActionTypes.WHO_AM_I_BACKGROUND_START,
  } as const);
export const initAutoRefresh = () =>
  ({
    type: authActionTypes.INIT_AUTO_REFRESH,
  } as const);
export const refreshToken = () =>
  ({
    type: authActionTypes.REFRESH_TOKEN_START,
  } as const);
export const refreshTokenSuccess = (token: authActionsInterfaces.Token) =>
  ({
    type: authActionTypes.REFRESH_TOKEN_SUCCESS,
    payload: { token },
  } as const);
export const refreshTokenFail = () =>
  ({
    type: authActionTypes.REFRESH_TOKEN_FAIL,
  } as const);
export const executeErrorCode = (code: number, failedAction: AnyAction, error?: Error) =>
  ({
    type: authActionTypes.EXECUTE_ERROR_CODE,
    payload: { code, failedAction, error },
  } as const);
export const executeActionCode = (code: number) =>
  ({
    type: authActionTypes.EXECUTE_ERROR_CODE,
    payload: { code },
  } as const);
export const redirectToAuthService = () =>
  ({
    type: authActionTypes.REDIRECT_TO_AUTH_SERVICE,
  } as const);
export const redirectToCASLogout = () =>
  ({
    type: authActionTypes.REDIRECT_TO_CAS_LOGOUT,
  } as const);
export const accumulateAction = (action: AnyAction) =>
  ({
    type: authActionTypes.ACCUMULATE_ACTION,
    payload: { action },
  } as const);
export const clearAccumulator = () =>
  ({
    type: authActionTypes.CLEAN_ACCUMULATOR,
  } as const);
export const resetUser = () =>
  ({
    type: authActionTypes.RESET_USER,
  } as const);
export const logout = () =>
  ({
    type: authActionTypes.LOGOUT,
  } as const);
export const resetReducers = () =>
  ({
    type: authActionTypes.RESET_REDUCERS,
  } as const);
